export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-blogger-ceb5334265de070327989778c6cbecfc.svg";